import PropTypes from 'prop-types'
import Button from '@/shared/components/UI/Button'

const StepDiscount = ({ onAccept, onDecline, isAcceptLoading, isCancelLoading }) => {
  return (
    <div className="flex flex-col items-center gap-v3-md text-center w-full">
      {/* Header */}
      <div className="flex flex-col items-center gap-v3-xs">
        <h2 className="text-v3-h3 font-bold text-v3-black-max text-center">
          One last thing before you go
        </h2>
        <p className="text-v3-black-secondary text-v3-h9 text-center">
          You know your business best. Sometimes timing just isn&apos;t right. We get it.
        </p>
      </div>

      {/* Offer card */}
      <div className="w-full rounded-v3-lg border-2 border-v3-purple-primary bg-v3-purple-bg p-v3-md flex flex-col items-center gap-v3-xs text-center max-w-[80%] mx-auto">
        <span className="text-5xl">🎁</span>
        <p className="text-v3-h2 font-bold text-v3-purple-primary">60% off</p>
        <p className="text-v3-h6 font-medium text-v3-black-max">for your next month</p>
        <p className="text-v3-h10 text-v3-black-secondary">
          Discount applied to your next invoice. No commitment required.
        </p>
      </div>

      {/* Urgency note */}
      <div className="w-full rounded-v3-sm bg-white border border-v3-card-border px-v3-md py-v3-sm text-center">
        <p className="text-[13px] text-v3-black-primary font-medium">
          ⚡ This offer is only available right now - it won&apos;t appear again.
        </p>
      </div>

      {/* Buttons */}
      <div className="flex flex-col gap-v3-sm w-full items-center">
        <Button
          variant="primary"
          size="lg"
          label="Accept - keep my account at 60% off"
          onClick={onAccept}
          loading={isAcceptLoading}
          loadingLabel="Applying discount..."
        />
        <Button
          variant="transparent"
          label="Decline and cancel my subscription"
          onClick={onDecline}
          loading={isCancelLoading}
          disabled={isAcceptLoading}
          loadingLabel="Cancelling..."
        />
      </div>
    </div>
  )
}

StepDiscount.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  isAcceptLoading: PropTypes.bool,
  isCancelLoading: PropTypes.bool,
}

StepDiscount.defaultProps = {
  isAcceptLoading: false,
  isCancelLoading: false,
}

export default StepDiscount
